
import useFetchData from "../Hooks/useFetchData";
const useValidateRole = (rolename, action) => {
  let UserId = window.sessionStorage.getItem("UserId");
  const UserRoles = useFetchData("/api/UserRoles/byUserId?userId="+UserId);
  if (UserRoles.response) {
    let role = UserRoles.response.data.find((obj) => obj.permission.name === rolename);
    if (role) {
      if (action === "AddNew") {
        if (role.addRecord===1) {
          return true;
        } else {
          return false;
        }
      } else if (action === "View") {
        if (role.viewRecord===1) {
          return true;
        } else {
          return false;
        }
      } else if (action === "Edit") {
        if (role.editRecord===1) {
          return true;
        } else {
          return false;
        }
      } else if (action === "Export") {
        if (role.exportRecord===1) {
          return true;
        } else {
          return false;
        }
      } else if (action == "Remove") {
        if (role.deleteRecord===1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export default useValidateRole;
